import { Component, OnInit } from '@angular/core';
import { MouvementsProduitsService } from 'src/app/data/declaration/services/mouvements/mouvements-produits.service';
import { HistoriqueMouvement } from 'src/app/data/declaration/models/historique-mouvement.model';
import { Referentiel } from 'src/app/data/declaration/models/referentiel.model';
import { ReferentielService } from 'src/app/data/declaration/services/referentiel/referentiel.service';
import { forkJoin } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CategorieEnum } from 'src/app/data/edition/models/enums/categorie.enum.model';
import { TelechargerDocumentComponent } from '../main/components/telecharger-document/telecharger-document.component';
import { DetailControleComponent } from './modal/detail-controle/detail-controle.component';
import { remove } from 'lodash';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LotSaisiesRevendications } from 'src/app/data/declaration/models/lot-saisies-revendications.model';
import { SaisieRevendicationResult } from 'src/app/data/declaration/interfaces/saisie-revendication-result.interface';
import { SaisieRevendication } from 'src/app/data/declaration/models/saisie-revendication.model';
import { ChangementsDenominationComponent } from '../declarations/pages/synthese-volumes/modals/changements-denomination/changements-denomination.component';
import { StockCode } from 'src/app/data/declaration/models/enums/stock.enum';
import { TypeCahierCode } from 'src/app/data/habilitation/models/enums/type-cahier-code.enum';
import { ProduitsService } from 'src/app/data/habilitation/services/produits/produits.service';
import { SaisirConditionnementComponent } from '../declarations/pages/synthese-volumes/modals/saisir-conditionnement/saisir-conditionnement.component';
import { SaisirTransactionComponent } from '../declarations/pages/synthese-volumes/modals/saisir-transaction/saisir-transaction.component';
import { SaisirTirageComponent } from '../declarations/pages/synthese-volumes/modals/saisir-tirage/saisir-tirage.component';
import { Cahier } from '../../../data/habilitation/models/cahier.model';
import { SessionContext } from '../../../core/services/config/app.settings';
import { CahiersService } from '../../../data/commission/services/cahiers/cahiers.service';
import { LoaderService } from '../../../core/services/loader/loader.service';

@Component({
    selector: 'app-suivi-declarations',
    templateUrl: './suivi-declarations.component.html',
    styleUrls: ['./suivi-declarations.component.scss'],
    standalone: false
})
export class SuiviDeclarationsComponent implements OnInit {
    /**
     * Liste des mouvements
     */
    public historiques: HistoriqueMouvement[];

    /**
     * Liste des référentiels
     */
    public referentiel: Referentiel;

    /**
     * Tous les cahiers des charges associés à l'organisme connecté
     */
    public cahiers: Cahier[];

    /**
     * L'id de l'organisme connecté
     */
    public idOrganisme: number;

    /**
     * Search forme
     */
    public searchForm: UntypedFormGroup;

    // ── Dialog saisie revendication ──
    saisieDialogVisible = false;
    saisieDialogLot: LotSaisiesRevendications | undefined;
    saisieDialogIndex: number | undefined;

    // ── Dialog synthèse ──
    syntheseDialogVisible = false;
    syntheseLot: LotSaisiesRevendications | undefined;
    creerRevendicationSynthese = false;

    /**
     * Gette debut date déclaration
     */
    get debutDate() {
        return this.searchForm.get('debutDate');
    }

    /**
     * Getter fin date déclaration
     */
    get finDate() {
        return this.searchForm.get('finDate');
    }

    /**
     * Getter millésime
     */
    get annee() {
        return this.searchForm.get('annee');
    }

    /**
     * Getter décision de controle
     */
    get nonControlable() {
        return this.searchForm.get('non_controlable');
    }

    /**
     * Getter raison sociale
     */
    get raisonSociale() {
        return this.searchForm.get('raisonSociale');
    }

    /**
     * Getter suivi
     */
    get suivi() {
        return this.searchForm.get('suivi');
    }

    /**
     * Getter type déclaration
     */
    get typeDeclaration() {
        return this.searchForm.get('typeDeclaration');
    }

    /**
     * Getter cahier des charges
     */
    get cdc() {
        return this.searchForm.get('cdc');
    }

    constructor(
        private readonly loader: LoaderService,
        private readonly mouvementsProduitsService: MouvementsProduitsService,
        private readonly fb: UntypedFormBuilder,
        private readonly referentielService: ReferentielService,
        private readonly translate: TranslateService,
        private readonly toastr: ToastrService,
        private readonly modalService: NgbModal,
        private readonly modalsService: ModalService,
        private readonly produitsService: ProduitsService,
        private readonly cahierService: CahiersService
    ) {
        this.idOrganisme = SessionContext.get('idOrganisme');
    }

    /**
     * On init component
     */
    ngOnInit() {
        // Instancier le formulaire de recherche
        this.searchForm = this.fb.group({
            raisonSociale: undefined,
            annee: undefined,
            non_controlable: undefined,
            debutDate: undefined,
            finDate: undefined,
            suivi: false,
            typeDeclaration: undefined,
            cdc: undefined
        });

        this.loadData();
    }

    /** Charge la liste des mouvements non lus et le référentiel */
    private loadData() {
        forkJoin(
            this.mouvementsProduitsService.getSuiviMouvement('', '', '', null, null, 'false', null, null),
            this.referentielService.getReferentiel(),
            this.cahierService.getCahiersByOrganisme(this.idOrganisme)
        )
            .pipe(this.loader.operator())
            .subscribe(([historiques, referentiel, cahiers]) => {
                this.historiques = historiques;
                this.historiques = historiques.sort((a, b) => new Date(b.dateDebut).getTime() - new Date(a.dateDebut).getTime());
                this.referentiel = referentiel;
                this.referentiel.refMouvements = referentiel.refMouvements.sort((a, b) => a.libelle.localeCompare(b.libelle));
                this.cahiers = cahiers.sort((a, b) => a.libelle.localeCompare(b.libelle));
            });
    }

    /**
     * Retourne le type d'un mouvement en fonction de son code
     * @param code String représentant le code du mouvement recherché
     */
    public getTypeMouvement(code: string): string {
        let libelle = '';

        if (this.referentiel && this.referentiel.refMouvements) {
            const mouvement = this.referentiel.refMouvements.find(m => m.code === code);
            libelle = mouvement ? mouvement.libelle : '';
        }

        return libelle;
    }

    /**
     * Met à jour le statut de tous les mouvements
     * @param lu Booléen représentant l'état auquel passer les mouvements
     */
    public onPasserToutALuOuNonLu(lu: boolean): void {
        if (this.historiques) {
            const idsMouvements: number[] = [];
            this.historiques.forEach(historique => {
                if (!historique.estLu) {
                    historique.estLu = lu;
                    idsMouvements.push(historique.idMouvement);
                }
            });
            this.mouvementsProduitsService.setMouvementLu(idsMouvements).subscribe();
        }
    }

    /**
     * Inverse le statut d'un seul mouvement
     * @param historique Un HistoriqueMouvement dont l'état est à modifier
     * @see HistoriqueMouvement
     */
    public onChangerStatut(historique: HistoriqueMouvement): void {
        historique.estLu = !historique.estLu;
        this.mouvementsProduitsService.setMouvementLu([historique.idMouvement]).subscribe();
    }

    public onChangerStatutNonLu(historique: HistoriqueMouvement): void {
        historique.estLu = !historique.estLu;
        this.mouvementsProduitsService.setMouvementNonLu([historique.idMouvement]).subscribe();
    }

    /**
     * Filter the search
     */
    search() {
        if (this.searchForm.valid) {
            const annee = this.annee.value;
            const raisonSociale = this.raisonSociale.value;
            const nonControlable = this.nonControlable.value as string;
            const suivi = this.suivi.value as string;
            const finDate = this.finDate.value;
            const debutDate = this.debutDate.value;
            const typeDeclaration = this.typeDeclaration.value ? this.typeDeclaration.value.map(d => d.code) : null;
            const cdc = this.cdc.value ? this.cdc.value.map(c => c.libelle) : null;

            this.mouvementsProduitsService
                .getSuiviMouvement(
                    raisonSociale,
                    annee,
                    nonControlable,
                    this.getMomentDate(debutDate),
                    this.getMomentDate(finDate),
                    suivi,
                    typeDeclaration,
                    cdc
                )
                .pipe(this.loader.operator())
                .subscribe(historiques => {
                    this.historiques = historiques;
                    this.historiques = historiques.sort((a, b) => new Date(b.dateDebut).getTime() - new Date(a.dateDebut).getTime());
                });
        }
    }

    /**
     * Change status
     * @param mouvement - Mouvement
     * @param ischeck - True if checking value
     */
    changeStatus(mouvement: HistoriqueMouvement, ischeck: boolean) {
        this.mouvementsProduitsService
            .setMouvementNonControlable(mouvement.idMouvement, ischeck)
            .pipe(this.loader.operator())
            .subscribe(() => {
                mouvement.nonControlable = ischeck;
            });
    }

    /**
     * Transforme une date provenant d'un Datepicker en date momentJS
     * @param date La date provenant d'un Datepicker
     * @see moment.Moment
     */
    private getMomentDate(date: { year: number; month: number; day: number }): moment.Moment {
        return date ? moment([date.year, date.month - 1, date.day, 0, 0, 0]) : null;
    }

    /**
     * Télécharger le document
     * @param mouvement - Mouvement
     */
    public telechargerDocument(mouvement: HistoriqueMouvement) {
        const modalRef = this.modalService.open(TelechargerDocumentComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.declaration = mouvement;
        modalRef.componentInstance.categorie = CategorieEnum.DECLARATION;
        modalRef.result.then(
            () => {
                // intentionally empty: waiting for change detection
            },
            error => {
                throw error;
            }
        );
    }

    /**
     * On edit
     * @param mouvement - Mouvement
     */
    public onEdit(mouvement: HistoriqueMouvement): void {
        const modal = this.modalService.open(DetailControleComponent, { backdrop: 'static', windowClass: 'app-modal-1000px' });
        modal.componentInstance.idOperateur = mouvement.idOperateur;
        modal.componentInstance.annee = mouvement.annee;
        modal.result.then();
    }

    /**
     * Modifier mouvement
     * @param mouvement - Mouvement à modifier
     */
    public modifierMouvement(mouvement: HistoriqueMouvement) {
        switch (mouvement.code) {
            case 'REVENDICATION':
                this.mouvementsProduitsService.getLotRevendications(mouvement.idOperateur, mouvement.idMouvement).subscribe(SaisieRevendications => {
                    const lotRevendications = new LotSaisiesRevendications(
                        mouvement.produit.idCahier,
                        mouvement.libelleCahier,
                        SaisieRevendications[0].date,
                        SaisieRevendications[0].entreposage,
                        mouvement.annee.toString(),
                        mouvement.idOperateur,
                        this.referentiel
                    );

                    let indexAModifier = 0;
                    SaisieRevendications.forEach((saisie: SaisieRevendication, index: number) => {
                        if (saisie.id === mouvement.idMouvement) {
                            indexAModifier = index;
                        }
                        lotRevendications.revendications.push(saisie);
                    });

                    this.SaisirRevendicationIgp(lotRevendications, indexAModifier);
                });
                break;

            case 'CHANGEMENT_DENOMINATION':
                this.mouvementsProduitsService.getChangementDenomination(mouvement.idOperateur, mouvement.idMouvement).subscribe(changementDenomination => {
                    this.produitsService.getProduitByCode(changementDenomination.codeProduitOrigine).subscribe(produit => {
                        changementDenomination.idOperateur = mouvement.idOperateur;
                        changementDenomination.produitOrigine = produit;
                        const modal = this.modalService.open(ChangementsDenominationComponent, {
                            backdrop: 'static',
                            windowClass: 'app-modal-1000px'
                        });

                        modal.componentInstance.produitsOrigine = [produit];
                        modal.componentInstance.stockOrigine = StockCode.REVENDIQUE;
                        modal.componentInstance.typeCahier = TypeCahierCode.IGP;
                        modal.componentInstance.changementAModifier = changementDenomination;
                        modal.componentInstance.campagne = mouvement.annee;
                        modal.componentInstance.estCreation = false;

                        modal.result.then(() => {
                            this.search();
                        });
                    });
                });
                break;

            case 'CONDITIONNEMENT':
                this.mouvementsProduitsService.getConditionnement(mouvement.idOperateur, mouvement.idMouvement).subscribe(conditionnement => {
                    conditionnement.idOperateur = mouvement.idOperateur;

                    const modal = this.modalService.open(SaisirConditionnementComponent, {
                        backdrop: 'static',
                        windowClass: 'app-modal-1000px'
                    });
                    modal.componentInstance.syntheseProduit = conditionnement.produit;
                    modal.componentInstance.estCreation = false;
                    modal.componentInstance.conditionnementAModifier = conditionnement;
                    modal.componentInstance.campagne = conditionnement.assemblages
                        .reduce((max, cond) => (max.volume > cond.volume ? max : cond))
                        .annee.toString();

                    modal.result.then(() => {
                        this.loadData();
                    });
                });

                break;

            case 'TRANSACTION':
                this.mouvementsProduitsService.getTransaction(mouvement.idOperateur, mouvement.idMouvement).subscribe(transaction => {
                    transaction.idOperateur = mouvement.idOperateur;

                    const modal = this.modalService.open(SaisirTransactionComponent, {
                        backdrop: 'static',
                        windowClass: 'app-modal-1000px'
                    });
                    modal.componentInstance.produit = transaction.produit;
                    modal.componentInstance.estCreation = false;
                    modal.componentInstance.transactionAModifier = transaction;
                    modal.componentInstance.campagne = transaction.assemblages.reduce((max, cond) => (max.volume > cond.volume ? max : cond)).annee.toString();

                    modal.result.then();
                });
                break;

            case 'TIRAGE':
                this.mouvementsProduitsService.getTirage(mouvement.idOperateur, mouvement.idMouvement).subscribe(tirage => {
                    const modal = this.modalService.open(SaisirTirageComponent, {
                        backdrop: 'static',
                        windowClass: 'app-modal-1000px'
                    });
                    tirage.idOperateur = mouvement.idOperateur;
                    tirage.idOperateur = mouvement.idOperateur;
                    modal.componentInstance.syntheseProduit = tirage.produitBase;
                    modal.componentInstance.estCreation = false;
                    modal.componentInstance.tirageAModifier = tirage;
                    const assemblageMax = tirage.assemblages.reduce(
                        (max, cond) => (!max || max.volume > cond.volume ? max : cond),
                        null as (typeof tirage.assemblages)[number] | null
                    );

                    modal.componentInstance.campagne = assemblageMax?.annee?.toString();
                    modal.result.then();
                });
                break;

            default:
                break;
        }
    }

    /**
     * Saisir revendication IGP
     * @param lotRevendications - Lot de revendications
     * @param indexAModifier - Index à modifier
     */
    SaisirRevendicationIgp(lotRevendications: LotSaisiesRevendications, indexAModifier: number) {
        this.saisieDialogLot = lotRevendications;
        this.saisieDialogIndex = indexAModifier;
        this.saisieDialogVisible = true;
    }

    onSaisieRevendicationTerminer(lot: LotSaisiesRevendications) {
        this.syntheseLot = lot;
        this.creerRevendicationSynthese = false;
        this.syntheseDialogVisible = true;
    }

    onSyntheseRevendicationClose(result: SaisieRevendicationResult | null) {
        if (result?.saisieTerminee) {
            this.search();
        } else if (result) {
            this.SaisirRevendicationIgp(result.lotRevendications, result.indexAModifier);
        }
    }

    /**
     * Supprimer un mouvement
     * @param mouvement - Mouvement à supprimer
     */
    public supprimerMouvement(mouvement: HistoriqueMouvement) {
        this.modalsService
            .confirm(
                `${this.translate.instant('page.declarations.suivi-declarations.confirm_remove.message')} ${mouvement.numeroLot} ?`,
                this.translate.instant('page.declarations.suivi-declarations.confirm_remove.title'),
                { cancelText: this.translate.instant('label.annuler'), submitText: this.translate.instant('label.valider') }
            )
            .then(() => {
                this.mouvementsProduitsService.desactiverMouvement(mouvement.idMouvement).subscribe(() => {
                    remove(this.historiques, mouvement);
                    this.toastr.success(
                        this.translate.instant('page.declarations.suivi-declarations.alert.suppression.message', { numero: mouvement.numeroLot }),
                        this.translate.instant('page.declarations.suivi-declarations.alert.suppression.title'),
                        { timeOut: 10 * 1000 }
                    );
                });
            });
    }

    miseAJourMillesime(annee: number){
        return annee===9999 ? 'Non millésimé' : annee;
    }
}
